import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import ReactDOM from "react-dom";

function DropDownButtonTime({
  options,
  handleOptionChange,
  initialOption,
  isPeople = false,
  update,
  setUpdate = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialOption);
  const selectedRef = useRef(null);
  const buttonRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const [openUpward, setOpenUpward] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedOption(initialOption);
  }, [initialOption]);

  useEffect(() => {
    if (isOpen && buttonRef.current && dropdownRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      const shouldOpenUp =
        spaceBelow < dropdownHeight && spaceAbove > dropdownHeight;
      setOpenUpward(shouldOpenUp);

      setDropdownPosition({
        top: shouldOpenUp
          ? rect.top + window.scrollY - dropdownHeight
          : rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOpen]);
  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOpen]);

  const handleSelect = (option, e) => {
    e.preventDefault();
    setSelectedOption(option);
    handleOptionChange(option);
    setIsOpen(false);
    if (setUpdate) {
      setUpdate(update + 1);
    }
  };

  const handleOpen = (e) => {
    e.preventDefault();
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <div className="form-control-people" onClick={handleOpen} ref={buttonRef}>
        <DropDownButtonLeft isPeopleAndZero={isPeople && selectedOption === 0}>
          {isPeople && selectedOption === 0
            ? "nº Pessoas"
            : selectedOption.replace(":", "h ") + "m"}
        </DropDownButtonLeft>
        <DropDownButtonRight>
          <div className={`arrow-icon ${isOpen ? "rotate-menu-arrow" : ""}`}>
            <FontAwesomeIcon
              icon={faChevronCircleDown}
              size="xl"
              color="#99B0AD"
            />
          </div>
        </DropDownButtonRight>
      </div>

      {isOpen &&
        ReactDOM.createPortal(
          <div
            ref={dropdownRef}
            className="custom-dropdown-menu"
            style={{
              position: "absolute",
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
              width: `${dropdownPosition.width}px`,
              zIndex: 9999,
            }}
          >
            {options.map((option, index) => (
              <div
                className={`dropdown-menu-item ${
                  option === selectedOption ? "selected" : ""
                }`}
                key={index}
                onClick={(e) => handleSelect(option, e)}
                ref={option === selectedOption ? selectedRef : null}
              >
                {option.replace(":", "h ") + "m"}
              </div>
            ))}
          </div>,
          document.body
        )}
    </>
  );
}

export default DropDownButtonTime;

const DropDownButtonLeft = styled.div`
  padding: 2px;
  display: flex;
  height: 100%;
  width: 70%;
  align-items: center;
  justify-content: center;
  border-right: 1px solid gray;
  cursor: pointer;
  color: #99b0ad;
  font-size: 12px;
  font-weight: bold;
  background-color: white;
  border-radius: 5px 0 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DropDownButtonRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: gray;
  text-align: center;
  width: 30%;
  cursor: pointer;
  background-color: white;
  border-radius: 0 5px 5px 0;
`;
